/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P3_Trail_EndInputs */

const en_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial end date`)
};

const ar_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ انتهاء الفترة التجريبية`)
};

const de_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ende des Trails`)
};

const es_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de finalización de la prueba`)
};

const fr_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de fin de l'essai`)
};

const it_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di fine della prova`)
};

const ja_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアル終了日`)
};

const ko_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체험 종료일`)
};

const pt_br_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de encerramento do teste`)
};

const ru_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата окончания пробной версии`)
};

const th_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันสิ้นสุดการทดลอง`)
};

const tr_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme bitiş tarihi`)
};

const zh_cn_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用到期日`)
};

const zh_tw_subscription_walkthrough_p3_trail_end = /** @type {(inputs: Subscription_Walkthrough_P3_Trail_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試用到期日`)
};

/**
* | output |
* | --- |
* | "Trial end date" |
*
* @param {Subscription_Walkthrough_P3_Trail_EndInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p3_trail_end = /** @type {((inputs?: Subscription_Walkthrough_P3_Trail_EndInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P3_Trail_EndInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "de") return de_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "es") return es_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "it") return it_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "th") return th_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p3_trail_end(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p3_trail_end(inputs)
	return zh_tw_subscription_walkthrough_p3_trail_end(inputs)
});